import styled from 'styled-components'

export const CreditAnalysisWrap = styled.div`
  .images {
    padding: 2.375rem 2.063rem;
  }
`
